<template>
    <div class="container" style="float: none;">
        <loader v-if="mediaLoading"/>
        <div v-for="mediaType in docMediaTypes" :value="mediaType.mediaTypeId" :key="mediaType.mediaTypeId" class="form-group">
            <label class="col-md-2 control-label text-label">{{mediaType.name}}</label>
            <div class="col-md-10">
                <table v-show="mediaList.find(x=> {return x.mediaTypeId === mediaType.mediaTypeId})" class="table">
                    <thead>
                        <tr>
                            <th style="width:10%">Download</th>
                            <th style="width:15%" v-if="mediaType.name === 'Images*'">Image Type</th>
                            <th style="width:15%" v-if="mediaType.name === 'Laboratory Results'">Lab Results Type</th>
                            <th style="width:25%">File Name</th>
                            <th style="width:25%">Comment</th>
                            <th style="width:15%">Uploaded By</th>
                            <th style="width:10%" v-if="!formDisabled || (isConsultant && mediaType.mediaTypeId === 7)">Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="mediaItem in mediaList.filter(m => {return m.mediaTypeId === mediaType.mediaTypeId})" :value="mediaItem.mediaId" :key="mediaItem.mediaId">
                            <td>
                                <div style="text-align: center;">
                                    <a class="fa fa-cloud-download" style="font-size: 18px;" target="_blank" v-on:click="mediaDownloadRow(mediaItem.mediaId, mediaItem.mediaTypeId, mediaType.mediaSubtype, mediaItem.parentId, mediaItem.filename)"></a>
                                </div>
                            </td>
                            <td v-if="mediaType.name === 'Images*'">{{ imageSubtypes.find(x => { return x.mediaSubtypeId === mediaItem.mediaSubtypeId }).name }}</td>
                            <td v-if="mediaType.name === 'Laboratory Results'">{{ (labResultsSubtypes.find(x => { return x.mediaSubtypeId === mediaItem.mediaSubtypeId }) || {name: ''}).name }}</td>
                            <td>{{mediaItem.filename}}</td>
                            <td>{{mediaItem.comment}}</td>
                            <td>{{mediaItem.createdBy}}</td>
                            <td v-if="!formDisabled || (isConsultant && mediaItem.mediaTypeId === 7)">
                                <div style="text-align: center;">
                                    <a class="fa fa-ban" style="font-size: 18px;" target="_blank" v-on:click="mediaRemove(mediaItem.mediaId, mediaItem.mediaSubtypeId)"></a>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-show="!(mediaList.find(x=> {return x.mediaTypeId === mediaType.mediaTypeId}))">
                    <label>No matching records</label>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-2">Add File</label>
            <div class="col-md-10">
                <fieldset :disabled="formDisabled && !isConsultant">
                    <form v-on:submit.prevent class="form" id="mediaForm" data-vv-scope="mediaFile">
                        <div class="row">
                            <div class="col-md-2">
                                <div class="form-group" v-bind:class="{ 'has-error': errors.has('mediaFile.mediaTypeId') }">
                                    <label>Type</label>
                                    <select name="mediaTypeId" class="form-control" v-model="mediaTypeId" v-validate="'required'" data-vv-validate-on="none">
                                        <option disabled value=''>Select a value</option>
                                        <option v-for="mediaType in docUploadMediaTypes" :value="mediaType.mediaTypeId" :key="mediaType.mediaTypeId">
                                            {{mediaType.name}}
                                        </option>
                                    </select>
                                    <div><span v-show="errors.has('mediaFile.mediaTypeId')" class="has-error">File type is required</span></div>
                                </div>
                            </div>
                            <div v-if="mediaTypeId === 5 || mediaTypeId === 7" class="col-md-2">
                                <div class="form-group" v-bind:class="{ 'has-error': errors.has('mediaFile.mediaSubtypeId') }">
                                    <label>Subtype</label>
                                    <select name="mediaSubtypeId" class="form-control" v-model="mediaSubtypeId" v-validate="'required'" data-vv-validate-on="none">
                                        <option disabled value=''>Select a value</option>
                                        <option v-show="mediaTypeId === 5" v-for="subtypes in imageUploadSubtypes" :value="subtypes.mediaSubtypeId" :key="subtypes.mediaSubtypeId">
                                            {{subtypes.name}}
                                        </option>
                                        <option v-show="mediaTypeId === 7" v-for="subtypes in labResultsSubtypes" :value="subtypes.mediaSubtypeId" :key="subtypes.mediaSubtypeId">
                                            {{subtypes.name}}
                                        </option>
                                    </select>
                                    <div><span v-show="errors.has('mediaFile.mediaSubtypeId')" class="has-error">Subtype is required</span></div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group" v-bind:class="{ 'has-error': errors.has('mediaFile.newFile') }">
                                    <label>File</label><br>
                                    <input name="newFile" ref="newFile" class="file" type="file" v-validate="'required'" data-vv-validate-on="none">
                                    <div><span v-show="errors.has('mediaFile.newFile')" class="has-error">File is required</span></div>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <div class="form-group" v-bind:class="{ 'has-error': errors.has('mediaFile.comment') }">
                                    <label>Comment</label>
                                    <input name="comment" type="text" class="form-control" v-model="comment" v-validate="'required'" data-vv-validate-on="none">
                                    <div><span v-show="errors.has('mediaFile.comment')" class="has-error">Comment is required</span></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <button class="btn btn-primary" v-on:click="addFile">Upload</button>
                            <label style="color: red; margin-left: 15px;">*Included in pdf form</label>
                        </div>
                    </form>
                </fieldset>
            </div>
        </div>
        <labResults ref="labResults" :loadOnMount="true" :crrId="crrId" :formDisabled="formDisabled && !isConsultant" v-on:radioCarbonNewSave="saveRadioCarbonFile"/>
    </div>
</template>

<script>
import mediaService from '../../services/mediaService'
import loggingService from '../../services/util/loggingService'
import rockArtService from '../../services/siteForm/rockArtService'
import historicBuildingService from '../../services/siteForm/historicBuildingService'
import radioCarbonReportService from '@/services/radioCarbonReportService'
import roleService from '@/services/roleService.js'
import userService from '@/services/userService.js'
import labResults from '@/components/LabResults.vue'
import { mapState } from 'vuex'
import loader from '@/components/Loader.vue'

export default {
    components: {
        labResults: labResults,
        loader
    },
    name: 'siteFormDocuments',
    data: function () {
        return {
            isDebug: false,
            mediaLoading: false,
            crrId: this.$route.params.culturalResourceRecordingId,
            docMediaTypes: [
                {name: 'Shape Files', mediaTypeId: mediaService.mediaType.CulturalResourceShapeFile},
                {name: 'Supporting Documents', mediaTypeId: mediaService.mediaType.CulturalResourceSupportingDocuments},
                {name: 'Correspondence', mediaTypeId: mediaService.mediaType.CulturalResourceCorrespondence},
                {name: 'Sketch Map*', mediaTypeId: mediaService.mediaType.CulturalResourceSketchMap},
                {name: 'Laboratory Results', mediaTypeId: mediaService.mediaType.CulturalResourceLabResults},
                {name: 'Images*', mediaTypeId: mediaService.mediaType.CulturalResourceImages}
            ],
            imageSubtypes: [
                {name: 'Site Overview', mediaSubtypeId: mediaService.mediaSubtype.SiteOverviewImage},
                {name: 'Artifact', mediaSubtypeId: mediaService.mediaSubtype.ArtifactImage},
                {name: 'Feature', mediaSubtypeId: mediaService.mediaSubtype.FeatureImage},
                {name: 'Rock Art', mediaSubtypeId: mediaService.mediaSubtype.RockArtImage},
                {name: 'Building', mediaSubtypeId: mediaService.mediaSubtype.BuildingImage},
                {name: 'Other', mediaSubtypeId: mediaService.mediaSubtype.OtherImage},
                {name: 'View Shed', mediaSubtypeId: mediaService.mediaSubtype.ViewShed}
            ],
            imageUploadSubtypes: [
                {name: 'Site Overview', mediaSubtypeId: mediaService.mediaSubtype.SiteOverviewImage},
                {name: 'Artifact', mediaSubtypeId: mediaService.mediaSubtype.ArtifactImage},
                {name: 'Feature', mediaSubtypeId: mediaService.mediaSubtype.FeatureImage},
                {name: 'Other', mediaSubtypeId: mediaService.mediaSubtype.OtherImage},
                {name: 'View Shed', mediaSubtypeId: mediaService.mediaSubtype.ViewShed}
            ],
            labResultsSubtypes: [
                {name: 'Radiocarbon', mediaSubtypeId: mediaService.mediaSubtype.RadioCarbon},
                {name: 'Material Sourcing', mediaSubtypeId: mediaService.mediaSubtype.MaterialSourcing},
                {name: 'Other Lab Results', mediaSubtypeId: mediaService.mediaSubtype.OtherLabResults}
            ],
            mediaList: [],
            comment: '',
            mediaTypeId: '',
            mediaSubtypeId: '',
            filename: '',
            radioCarbonGridSpec: {
                tableData: [],
                columns: ['download', 'recording', 'subtypeDescription', 'filename', 'comment', 'createdDate'],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 5,
                    perPageValues: [5, 10, 25],
                    headings: {
                        subtypeDescription: 'File Type',
                        filename: 'File Name',
                        comment: 'Comment',
                        createdDate: 'Upload Date'
                    },
                    dateColumns: ['createdDate'],
                    orderBy: {
                        ascending: false,
                        column: 'createdDate'
                    }
                }
            }
        }
    },
    props: {
        formDisabled: { default: false },
        loadOnMount: { default: true }
    },
    computed: {
        // compute current user info
        ...mapState({
            shpoUserDto: state => state.auth.shpoUserDto
        }),
        isConsultant: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.ConsultantUser])
        },
        docUploadMediaTypes: function () {
            if (this.formDisabled && this.isConsultant) {
                return [
                    {name: 'Laboratory Results', mediaTypeId: mediaService.mediaType.CulturalResourceLabResults}
                ]
            } else {
                return [
                    {name: 'Shape Files', mediaTypeId: mediaService.mediaType.CulturalResourceShapeFile},
                    {name: 'Supporting Documents', mediaTypeId: mediaService.mediaType.CulturalResourceSupportingDocuments},
                    {name: 'Correspondence', mediaTypeId: mediaService.mediaType.CulturalResourceCorrespondence},
                    {name: 'Sketch Map*', mediaTypeId: mediaService.mediaType.CulturalResourceSketchMap},
                    {name: 'Laboratory Results', mediaTypeId: mediaService.mediaType.CulturalResourceLabResults},
                    {name: 'Images*', mediaTypeId: mediaService.mediaType.CulturalResourceImages}
                ]
            }
        }
    },
    mounted () {
        if (this.loadOnMount) {
            this.loadData()
        }
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Site Form Documents', message)
        },
        loadMedia (mediaTypeId, mediaSubtypeId, parentId) {
            this.log('looking for parent: ' + parentId)
            return mediaService.list(this.$http, mediaTypeId, mediaSubtypeId, parentId).then(result => {
                this.mediaList = this.mediaList.concat(result.data)
                return result
            })
        },
        loadImages () {
            var promises = [this.loadRockArtImages(), this.loadBuildingImages()]
            this.imageSubtypes.filter(x => {
                return x.mediaSubtypeId !== mediaService.mediaSubtype.BuildingImage &&
                x.mediaSubtypeId !== mediaService.mediaSubtype.RockArtImage
            }).forEach(x => {
                promises.push(this.loadMedia(mediaService.mediaType.CulturalResourceImages, x.mediaSubtypeId, this.crrId))
            })
            return Promise.all(promises).then(result => { return result })
        },
        loadRockArtImages () {
            return rockArtService.search(this.$http, {culturalResourceRecordingId: this.crrId}).then(result => {
                var promises = []
                result.data.forEach(rockArt => {
                    promises.push(this.loadMedia(mediaService.mediaType.CulturalResourceImages, mediaService.mediaSubtype.RockArtImage, rockArt.rockArtPanelId))
                })
                Promise.all(promises).then(result => {
                    return result
                })
            })
        },
        loadBuildingImages () {
            return historicBuildingService.search(this.$http, {culturalResourceRecordingId: this.crrId}).then(result => {
                var promises = []
                result.data.forEach(building => {
                    promises.push(this.loadMedia(mediaService.mediaType.CulturalResourceImages, mediaService.mediaSubtype.BuildingImage, building.historicBuildingFormId))
                })
                Promise.all(promises).then(result => {
                    return result
                })
            })
        },
        loadLabResults () {
            var promises = []
            this.labResultsSubtypes.forEach(x => {
                promises.push(this.loadMedia(mediaService.mediaType.CulturalResourceLabResults, x.mediaSubtypeId, this.crrId))
            })
            return Promise.all(promises).then(result => { return result })
        },
        loadData () {
            this.mediaLoading = true
            var promises = [this.loadImages(), this.loadLabResults()]
            this.mediaList = []
            this.docMediaTypes.forEach(mediaType => {
                promises.push(this.loadMedia(mediaType.mediaTypeId, null, this.crrId))
            })
            Promise.all(promises).then(result2 => {
                this.log('After load, media list count: ' + this.mediaList.length)
                this.mediaLoading = false
            })
        },
        addFile () {
            this.$validator.validateAll('mediaFile').then(result => {
                if (result) {
                    var file = this.$refs['newFile'].files[0]
                    if (this.mediaSubtypeId === mediaService.mediaSubtype.RadioCarbon) {
                        //this is a radio carbon upload, call createNewReport from labResults component
                        this.$refs.labResults.createNewReport(this.crrId)
                    } else {
                        this.log(`Adding file. Type: ${this.mediaTypeId} Comment: ${this.comment} Name: ${file.name}`)
                        mediaService.putFile(this.$http, this.mediaTypeId, this.mediaSubtypeId, this.crrId, file, this.comment).then(result => {
                            this.clearFileInput()
                            this.loadData()
                            this.errors.clear()
                        })
                    }
                } else {
                    this.log('Submit File - Invalid Form')
                }
            })
        },
        // function to save the radio carbon media file and link the mediafile id to the radio carbon report
        saveRadioCarbonFile (radioCarbonReportDto) {
            var file = this.$refs['newFile'].files[0]
            this.log(`Adding file. Type: ${this.mediaTypeId} Comment: ${this.comment} Name: ${file.name}`)
            radioCarbonReportService.saveNewRadioCarbon(this.$http, radioCarbonReportDto, this.mediaTypeId, this.mediaSubtypeId, this.crrId, file, this.comment).then(result => {
                this.clearFileInput()
                this.loadData()
                this.$refs.labResults.loadData()
                this.errors.clear()
            })
        },
        clearFileInput () {
            document.forms['mediaForm'].reset()
            this.mediaTypeId = ''
            this.mediaSubtypeId = ''
            this.comment = ''
        },
        mediaDownloadRow (mediaId) {
            var mediaItem = this.mediaList.find(x => { return x.mediaId === mediaId })
            this.log(`mediaDownloadRow - mediaId: ${mediaItem.mediaId} , mediaTypeId: ${mediaItem.mediaTypeId}, parentId: ${mediaItem.parentId}`)
            mediaService.get(this.$http, mediaItem.mediaId, mediaItem.mediaTypeId, mediaItem.mediaSubtypeId, mediaItem.parentId).then(function (response) {
                mediaService.saveFileToDownload(response, mediaItem.filename)
            })
        },
        mediaRemove (mediaId, mediaSubtypeId) {
            if (confirm('Are you sure you want to delete this file/document? If you are deleting a Radiocarbon file, the corresponding Radiocarbon Report will also be deleted.')) {
                //if removing a Radio Carbon, use the radioCarbonService removeByMediaId route
                if (mediaSubtypeId === 8) {
                    radioCarbonReportService.removeByMediaId(this.$http, mediaId).then(result => {
                        this.loadData()
                        this.$refs.labResults.loadData()
                    })
                } else {
                    mediaService.removeByMediaId(this.$http, mediaId).then(result => {
                        this.loadData()
                        this.$refs.labResults.loadData()
                    })
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// SiteFormDocuments.vue?315ac33c